import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";
import { useSponsorValuePerSource } from "../query/hooks";

const SponsorSourceDividedValueChart = ({
  sponsorObjectId,
  selectedCurrency,
  tenant,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const {
    data: sources,
    isLoading,
    isRefetching,
    isSuccess,
  } = useSponsorValuePerSource(sponsorObjectId);
  
  console.log('SponsorSourceDividedValueChart sources:', sources);

  const chartOptions = (source) => {
    return {
      credits: {
        enabled: false
      },
      chart: {
        type: "bar",
      },
      title: {
        text: "",
      },
      yAxis: {
        title: {
          text: source.data.yTitle,
        },
        labels: {
          style: {
            color: 'var(--text-primary)',
          }
        },
      },
      xAxis: {
        categories: source.data.labels.slice(0, 15),
        labels: {
          animate: true,
          style: {
            color: 'var(--text-primary)',
          }
        }
      },
      series: source.data.series.map((serie) => ({
        ...serie,
        data: serie.data.slice(0, 15).map(point => {
          // point is an array [label, value] after transformation in the hook
          const value = Array.isArray(point) ? point[1] : (point.y || point);
          return Math.round((value || 0) * (selectedCurrency?.value || 1));
        }),
        dataSorting: {
          enabled: true,
        },
        borderColor: null,
      })),
      plotOptions: {
        column: {
          stacking: "normal",
        },
      },
    };
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const renderTab = (source, index) => {
    return (
      <NavItem key={index}>
        <NavLink
          href="#"
          className={classnames({
            active: activeTab === index,
          })}
          onClick={() => {
            toggleTab(index);
          }}
        >
          {source.source}
        </NavLink>
      </NavItem>
    );
  };

  const renderSource = (source, index) => {
    return (
      <TabPane tabId={index} className="p-3" key={index}>
        <HighchartsReact
          highcharts={Highcharts}
          options={chartOptions(source)}
        />
      </TabPane>
    );
  };

  return (
    <>
      {(isLoading || isRefetching) && <Spinner color="primary" />}
      {isSuccess && (
        <>
          <Nav pills className="navtab-bg my-4 center-pills">
            {sources.map((source, index) => renderTab(source, index))}
          </Nav>
          <TabContent activeTab={activeTab}>
            {sources.map((source, index) => renderSource(source, index))}
          </TabContent>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  selectedCurrency: state.currency.selectedCurrency,
  tenant: state.auth.tenant,
});

export default connect(mapStateToProps)(SponsorSourceDividedValueChart);
